export default "__VITE_ASSET__B5$C65s0__"